// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const PaymentsAPIService = {
    StartPayment(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/locations/${req["locationId"]}/payments`, { method: "POST", body: JSON.stringify(req["startPayment"], fm.replacer) });
    },
    StartRequestedPayment(fn, req) {
        try {
            fm.validateUrlParam(req["requestId"], "requestId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/requests/${req["requestId"]}/payments`, { method: "POST", body: JSON.stringify(req["startPayment"], fm.replacer) });
    },
    StartAuthenticatedRequestedPayment(fn, req) {
        try {
            fm.validateUrlParam(req["requestId"], "requestId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/portal/requests/${req["requestId"]}/payments`, { method: "POST", body: JSON.stringify(req["startPayment"], fm.replacer) });
    },
    StartAnonymousPayment(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/portal/${req["locationId"]}/payments`, { method: "POST", body: JSON.stringify(req["startPayment"], fm.replacer) });
    },
    GetPaymentPlanConfirmationDetails(fn, req) {
        try {
            fm.validateUrlParam(req["planId"], "planId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/${req["planId"]}/confirm?${fm.renderURLSearchParams(req, ["planId"])}`, { method: "GET" });
    },
    RequestPaymentPlanConfirmation(fn, req) {
        return fn(`/payments/v2/confirm`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    StartSyncAuthenticatedRequestedPayment(fn, req) {
        try {
            fm.validateUrlParam(req["requestId"], "requestId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/portal/requests/${req["requestId"]}/payments:sync`, { method: "POST", body: JSON.stringify(req["startPayment"], fm.replacer) });
    },
    StartSyncRequestedPayment(fn, req) {
        try {
            fm.validateUrlParam(req["requestId"], "requestId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/requests/${req["requestId"]}/payments:sync`, { method: "POST", body: JSON.stringify(req["startPayment"], fm.replacer) });
    },
    StartSyncAnonymousPayment(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/portal/${req["locationId"]}/payments:sync`, { method: "POST", body: JSON.stringify(req["startPayment"], fm.replacer) });
    },
    StartSyncPayment(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/locations/${req["locationId"]}/payments:sync`, { method: "POST", body: JSON.stringify(req["startPayment"], fm.replacer) });
    },
    ConfirmPayment(fn, req) {
        try {
            fm.validateUrlParam(req["paymentId"], "paymentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/payments/${req["paymentId"]}/confirm`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ConfirmAnonymousPayment(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["paymentId"], "paymentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/v2/portal/${req["locationId"]}/payments/${req["paymentId"]}/confirm`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
